// extracted by mini-css-extract-plugin
module.exports = {"container":"PostCard_container__2DLK5","card":"PostCard_card__1BqrZ"};